const $inject = ['$scope', 'lbMicrosoftMapsScriptService'];
const lbMapController = function ($scope, lbMicrosoftMapsScriptService) {

  let vm = this;

  vm.lbMicrosoftMapsScriptService = lbMicrosoftMapsScriptService;
  vm.map = null;
  vm.mapId = 'map' + $scope.$id;
  vm.showPushpin = showPushpin;
  vm.showPushPinCluster = showPushPinCluster;

  if(vm.gridSize == undefined){
    vm.gridSize = 30;
  }

  vm.lbMicrosoftMapsScriptService.load()
    .then(()=>{
      let navigationBarMode = Microsoft.Maps.NavigationBarMode;

      vm.map = new Microsoft.Maps.Map(document.getElementById(vm.mapId), {
        credentials: 'AqkExqjquai0sfSevSrsEaOMOzaNLUqDL4xFwXBnjbRJYaLxM_gh2TlGV42cXl1R',
        navigationBarMode: navigationBarMode.compact,
        center: new Microsoft.Maps.Location(vm.mapCenter.latitude, vm.mapCenter.longitude),
        zoom: vm.zoomLevel
      });

      if(vm.locations.length > 1){
        vm.showPushPinCluster(vm.locations);
      } else{
        vm.showPushpin(vm.locations[0]);
      }
    });

  function createInfoBox(location, options){
    return new Microsoft.Maps.Infobox(getLocation(location), options);
  }

  function updateInfoBox(infoBox, item){
    infoBox.setHtmlContent(`
      <div id="infoboxText" style="background-color:White; border-style:solid;
          border-width:medium; border-color:DarkOrange; min-height:100px; width: 240px; z-index: 1000000000000000000; ">
        <b id="infoboxTitle" style="position: absolute; top: 10px; left: 10px; width: 220px; ">${item.HotelName}</b>
        <a id="infoboxDescription" style="position: absolute; top: 30px; left: 10px; width: 220px; ">Description</a>
      </div>
    `);
  }

  function createPushpin(location, options){
    return new Microsoft.Maps.Pushpin(location, options);
  }

  function getLowercaseLocation(item){
    return {latitude: item.Latitude, longitude: item.Longitude}
  }

  function showPushpin(location){
    vm.map.entities.push(createPushpin(getLowercaseLocation(location), {}));
  }

  function getLocation(options){
    return new Microsoft.Maps.Location(options.latitude, options.longitude);
  }

  //
  //function pushpinOver(event) {
  //  showInfoBox(event.target.data);
  //}


  function hideInfoBox(infoBox) {
    infoBox.setOptions({
      visible: false
    });
  }

  function pushpinOut(infoBox) {
    vm.infoboxTimeout = setTimeout(function() {
      hideInfoBox(infoBox);
    }, 150);
  }


  function infoboxOver() {
      clearTimeout(vm.infoboxTimeout);
  }


  function infoboxOut(infoBox) {
    vm.infoboxTimeout = setTimeout(function() {
      hideInfoBox(infoBox);
    }, 150);
  }



  function showPushPinCluster(locations){

    let infoBox = createInfoBox(vm.mapCenter, {title: 'hi', showCloseButton: false});
    console.log('lbMapController.js line:99, infoBox:', infoBox);

    infoBox.setMap(vm.map);


    let pushpins = locations.map((item)=>{
      let pinLocation = getLocation(getLowercaseLocation(item));
      let pin = createPushpin(pinLocation, {});


      Microsoft.Maps.Events.addHandler(pin, 'mouseover', function () {

        infoBox.setLocation(pinLocation);
        infoBox.setOptions({visible: true});
        updateInfoBox(infoBox, item);
      });

      Microsoft.Maps.Events.addHandler(pin, 'mouseout', pushpinOut(infoBox));

      return pin;
    });


    Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', function () {
      let clusterLayer = new Microsoft.Maps.ClusterLayer(pushpins, { gridSize: vm.gridsize });
      vm.map.layers.insert(clusterLayer);
    });
  }
};

lbMapController.$inject = $inject;

export default lbMapController;



// WEBPACK FOOTER //
// ./src/components/lbMap/lbMapController.js